"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombinatorSelector = exports.ExpressionSelector = exports.PrimitiveMultiValueInput = exports.PrimiteValueInput = exports.PrimitiveColumnSelector = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const rebass_1 = require("rebass");
const mapQlPredicateToExpression_1 = require("../../../parser/src/predicate/mapQlPredicateToExpression");
const AdaptableInput_1 = tslib_1.__importDefault(require("../../../View/Components/AdaptableInput"));
const ColumnSelector_1 = require("../../../View/Components/Selectors/ColumnSelector");
const PermittedValuesSelector_1 = require("../../../View/Components/Selectors/PermittedValuesSelector");
const CheckBox_1 = require("../../CheckBox");
const DropdownButton_1 = tslib_1.__importDefault(require("../../DropdownButton"));
const icons_1 = require("../../icons");
const InputGroup_1 = require("../../InputGroup");
const Select_1 = require("../../Select");
const QueryBuilder_1 = require("./QueryBuilder");
const utils_1 = require("./utils");
const PrimitiveColumnSelector = (props) => {
    return (react_1.default.createElement(rebass_1.Box, null,
        react_1.default.createElement(ColumnSelector_1.ColumnSelector, { value: props.columnId, type: props.type, onChange: (columnId) => {
                props.onChange(`[${columnId}]`);
            } })));
};
exports.PrimitiveColumnSelector = PrimitiveColumnSelector;
const PrimiteValueInput = (props) => {
    var _a, _b;
    const [type, setType] = react_1.default.useState(() => {
        var _a;
        return typeof (props === null || props === void 0 ? void 0 : props.value) === 'string' && ((_a = props === null || props === void 0 ? void 0 : props.value) === null || _a === void 0 ? void 0 : _a.includes('['))
            ? 'column-name'
            : 'input-value';
    });
    const handleTypeChange = (newType) => {
        if (type !== newType) {
            // need to reset value
            props.onChange(undefined);
            setType(newType);
        }
    };
    const getEditor = () => {
        var _a, _b;
        const common = {
            'data-id': 'query-input',
        };
        switch (props.inputType) {
            case 'boolean':
                return (react_1.default.createElement(CheckBox_1.CheckBox, Object.assign({}, common, { checked: props.value, onChange: () => props.onChange(!props.value) })));
            case 'number':
                return (react_1.default.createElement(AdaptableInput_1.default, Object.assign({}, common, { type: "number", value: (_a = props.value) !== null && _a !== void 0 ? _a : '', onChange: (event) => {
                        const value = event.target.value;
                        if (value === '') {
                            props.onChange(undefined);
                        }
                        else {
                            props.onChange(parseFloat(value));
                        }
                    } })));
            case 'text':
                return (react_1.default.createElement(AdaptableInput_1.default, Object.assign({}, common, { type: "text", value: (_b = props.value) !== null && _b !== void 0 ? _b : '', onChange: (event) => {
                        props.onChange(event.target.value);
                    } })));
            case 'date':
                // date format = 'DATE(2020-01-01)'
                const dateStr = typeof props.value === 'string' ? props.value.replace('DATE(', '').replace(')', '') : '';
                return (react_1.default.createElement(AdaptableInput_1.default, Object.assign({}, common, { type: "date", value: dateStr !== null && dateStr !== void 0 ? dateStr : '', onChange: (event) => {
                        const stringified = `DATE("${event.target.value}")`;
                        props.onChange(stringified);
                    } })));
            default:
                return react_1.default.createElement(react_1.default.Fragment, null);
        }
    };
    let editor = null;
    if (type === 'column-name') {
        const columnId = props.value ? (_b = (_a = props === null || props === void 0 ? void 0 : props.value) === null || _a === void 0 ? void 0 : _a.replace) === null || _b === void 0 ? void 0 : _b.call(_a, '[', '').replace(']', '') : undefined;
        const abColType = (0, utils_1.mapExpressionFunctionTypeToColumnDataType)(props.inputType);
        editor = (react_1.default.createElement(exports.PrimitiveColumnSelector, { columnId: columnId, onChange: (col) => props.onChange(col), type: abColType }));
    }
    else if (!['date', 'boolean'].includes(props.inputType)) {
        editor = (react_1.default.createElement(PermittedValuesSelector_1.PermittedValuesSelector, { allowNewValues: true, value: props.value, columnId: props.lefthandColumnIdParam, onChange: (value) => {
                props.onChange(value);
            } }));
    }
    else {
        editor = getEditor();
    }
    const options = [
        {
            label: (react_1.default.createElement(rebass_1.Flex, null,
                react_1.default.createElement(icons_1.Icon, { name: "columns" }),
                react_1.default.createElement(rebass_1.Text, { ml: 2 }, "Column"))),
            icon: 'columns',
            value: 'column-name',
        },
        {
            label: (react_1.default.createElement(rebass_1.Flex, null,
                react_1.default.createElement(icons_1.Icon, { name: "edit" }),
                react_1.default.createElement(rebass_1.Text, { ml: 2 }, "Value"))),
            icon: 'edit',
            value: 'input-value',
        },
    ];
    const typeOption = options.find((option) => option.value === type);
    return (react_1.default.createElement(InputGroup_1.InputGroup, { Component: rebass_1.Flex, "data-id": "query-input-wrapper", mr: 2 },
        react_1.default.createElement(Select_1.Select, { rederSingleValue: (value) => {
                return (react_1.default.createElement(react_1.default.Fragment, null, typeOption.value === 'column-name' ? react_1.default.createElement(icons_1.Icon, { name: "grid" }) : react_1.default.createElement(icons_1.Icon, { name: "edit" })));
            }, value: typeOption.value, options: options, onChange: (value) => handleTypeChange(value) }),
        editor));
};
exports.PrimiteValueInput = PrimiteValueInput;
const PrimitiveMultiValueInput = (props) => {
    return (react_1.default.createElement(PermittedValuesSelector_1.PermittedValuesSelector, { isMulti: true, allowNewValues: true, value: props.value, columnId: props.lefthandColumnIdParam, onChange: (value) => {
            props.onChange(value);
        } }));
};
exports.PrimitiveMultiValueInput = PrimitiveMultiValueInput;
const ExpressionSelector = (props) => {
    var _a;
    const { getExpressions } = (0, QueryBuilder_1.useQueryBuilderContext)();
    const expressions = props.dataType ? getExpressions(props.dataType) : [];
    return (react_1.default.createElement(DropdownButton_1.default, { "data-id": "expression-selector", "data-value": props.value, variant: "raised", columns: ['label'], items: expressions.map((expression) => ({
            label: (0, mapQlPredicateToExpression_1.getQlPredicateSymbol)(expression),
            onClick: () => {
                if (expression !== props.value) {
                    props.onExpressionChange(expression);
                }
            },
        })) }, (_a = (0, mapQlPredicateToExpression_1.getQlPredicateSymbol)(props.value)) !== null && _a !== void 0 ? _a : 'Select Operator'));
};
exports.ExpressionSelector = ExpressionSelector;
const CombinatorSelector = (props) => {
    return (react_1.default.createElement(DropdownButton_1.default, { "data-id": "combinator-selector", "data-value": props.value, columns: ['label'], variant: "raised", tone: "accent", items: [
            { label: 'AND', onClick: () => props.onChange('AND') },
            { label: 'OR', onClick: () => props.onChange('OR') },
        ] }, props.value));
};
exports.CombinatorSelector = CombinatorSelector;
